import Channel from 'umg-ember-backend/components/record-explorer/for/channel';

<template><Channel @records={{@model}} @recordType='channel' /></template>
